import { render, staticRenderFns } from "./payment-reminder-list.vue?vue&type=template&id=69ad636b"
import script from "./payment-reminder-list.vue?vue&type=script&lang=js"
export * from "./payment-reminder-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports